<template>
	<div class="FlyOverMenu submenu">
		<ul>
			<li 
				v-for="(child) in children" 
				:key="child.name"
				class="childLink nav-item" 
			>
				<!-- {{child.}} -->
				<router-link
					:to="route.path + '/' +  child.path"
					:class="{hasChildren: child.children && child.children.length > 0}"
				>
					<span>{{child.menu.title}}</span>
				</router-link>
			</li>
			<!-- <li v-for="category of display" :key="category.id" class="categoryGrouping">
				<router-link :to="{name:'brands', query:{refine:category.id}}" class="categoryHeader">{{category.category}}</router-link> -->
			<ul class="brandGrouping">
				<li v-for="brand of display" :key="brand.id" class="brandListItem">
					<router-link :to="{name:'brand',params:{brand: brand.id, source: 'brands'}}" class="brandTitle">{{brand.title}}</router-link>
				</li>

			</ul>

			<!-- </li> -->
		</ul>
		<div class="much-more-text">
			<router-link :to="{'name': 'brands'}"> And Much More ... </router-link>
		</div>
	</div>
</template>

<script>

import { mapState } from "vuex";
import { fetchBrands, getRestrictedBrands, getFlyoverBrands } from "@/network/brandRequests";

export default {
	name: 'FlyOverMenu',
	components: {

	},
	data() {
		return {
			brandsData: [],
			limit: 5,
		}
	},
	props: ["flyOverDataType", "route"],
	created(){
		this.getData()
	},
	methods: {
		getData(){
			if (this.flyOverDataType == "brands") {
				fetchBrands(
					listing => {
						this.brandsData = Object.values(listing);
					},
					error => {
						console.log(error);
					}
				);
			}
		}
	},
	computed: {
		...mapState({
			// map categories to store.reference.categories
			categories: state => state.reference.categories,
			memberLevel: state => state.auth.memberLevel
		}),
		restrictedBrands(){
			if(this.memberLevel == "silver" || this.memberLevel == "public" ){
				return getRestrictedBrands
			}
			else{
				return []
			}
		},
		flyoverBrands(){
			return getFlyoverBrands
		},
		display() {
			let grouped = []
			if (this.flyOverDataType == "brands") {
				for (let brand of this.brandsData) {
					if (this.flyoverBrands.includes(brand.title)){
						grouped.push({id:brand.id, title:brand.title})
					}
				}
			}
			return grouped.sort((a, b) => {
				if (a.title < b.title) return -1
				if (a.title > b.title) return 1
				return 0
			})
		},
		children() {
			if (this.route.children && this.route.children.length >0) {
				return this.route.children
			}
			return []
		}
	},

}
</script>

<style lang="scss" scoped>
	.FlyOverMenu {
		width: 100%;
		position: absolute;
		left: 0;
		// border-radius: 5px;
	}

	// .categoryGrouping {
	// 	display: inline-block;
	// 	padding: 15px;
	// 	vertical-align: top;
	// }
	
	// .categoryHeader {
	// 	font-weight: bold;
	// 	color: black;
	// 	border-bottom: 1px #ddd solid;
	// 	display: block;
	// 	padding: 5px;
	// }

	.brandGrouping {
		padding: 5px 20px;
		display: grid;
		grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
		border-top: 2px solid #ccc;
		margin-right: 40px;
		padding-bottom: 15px;
		a {
			display: block;
		}
		li {
			padding: 3px 0;
		}
	}

	ul {
		display: block;
		list-style: none;
		li.nav-item{
			&:first-child{
				padding-top: 10px;
			}
			&:nth-child(2){
				padding-bottom: 5px;
			}
			& > a {
				padding: 0 10px; 
				text-decoration: none;
				display: block;
				color: black;
				&:hover span{
					text-decoration: underline;
				}
				&:before {
					content: '\BB';
					position: relative;
					left: -5px;
					top: -1px;
				}
			}
		}
	}

	.much-more-text a {
		background-color: $CTred;
		padding: 10px 20px;
		margin: 0;
		text-align: right;
		color: white;
		font-weight: bold;
		display: block;
		height: 100%;
		width: 100%;
		border-radius: 0 0 5px 5px;
		&:hover {
			background-color: $CTredHover;
		}
	}

</style>